var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-home",on:{"click":_vm.goHome}},[_c('span',[_vm._v("去首页")])])}
var staticRenderFns = []

export { render, staticRenderFns }